/* TODO: t() */
import React from 'react';

import PaymentList from './PaymentList';
import { useMarketSalesContext } from './Context';

import DataStore from '../../support/DataStore';
import { postJSON } from '../../support/Fetch';

import { MarketPayments } from '../../types/shared/MarketSales';
import { Modal } from '../uiold';

type Props = {
  onClose: () => void;
  marketPayments: MarketPayments;
};

let dataStore = DataStore.getInstance('app');

function ManagePayments(props: Props) {
  let { marketPayments, onClose } = props;
  let { activeMarket, allSales } = useMarketSalesContext();
  let onPaymentSave = async (paymentID: string, paymentName: string) => {
    if (!activeMarket || !allSales) {
      return;
    }
    let oldPayment = marketPayments[paymentID];
    if (!oldPayment) {
      return;
    }
    let oldPaymentAndSales = allSales[activeMarket.id];
    let newPayment = { ...oldPayment, name: paymentName };
    // Initializing object with empty data in the case that no sales
    if (!oldPaymentAndSales) {
      oldPaymentAndSales = {
        notes: {},
        noteCategories: {},
        sales: {},
        payments: {
          ...marketPayments,
          [paymentID]: newPayment,
        },
      };
    }
    let newPaymentAndSales = {
      ...allSales,
      [activeMarket.id]: {
        ...oldPaymentAndSales,
        payments: {
          ...marketPayments,
          [paymentID]: newPayment,
        },
      },
    };

    let result = await postJSON(
      `/api/redemptions/${activeMarket.id}/${paymentID}/edit`,
      newPayment,
    );

    if (result.success) {
      // This code will cause the market sales save button to appear
      // even though the new payment is already saved.
      dataStore.set('sales', newPaymentAndSales);
    }
  };

  return (
    <Modal
      isVisible
      title="Manage Payments"
      onClose={onClose}
      style={styles.root}
    >
      <Modal.Body style={styles.body}>
        <PaymentList
          marketPayments={marketPayments}
          onPaymentSave={onPaymentSave}
        />
      </Modal.Body>
    </Modal>
  );
}

let styles = {
  root: {
    height: '80vh',
    width: 800,
  },
  body: {
    flex: 1,
    paddingTop: 16,
  },
};

export default ManagePayments;
